module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_3-09d58faec6ebeccfeb943c5b64b0b0c8.png";